import { Upload, UploadProps } from "antd";
import ImgCrop from "antd-img-crop";
import { ReactNode } from "react";

interface Props extends UploadProps {
  children: ReactNode;
  aspect?: number | "any"; // Aspect ratio for cropping
  cropOnlyWhenAspectMismatch?: boolean;
  cropQuality?: number;
}

const imageMatchesAspect = (file: Blob, aspect: number) =>
  new Promise<boolean>((resolve) => {
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(image.src);
      resolve(Math.abs(image.width - image.height * aspect) <= 1);
    };
    image.onerror = () => {
      URL.revokeObjectURL(image.src);
      resolve(false);
    };
    image.src = URL.createObjectURL(file);
  });

/** Adds an optional aspect-ratio crop step before an Ant Design image upload. */
export const UploadWithCrop = (props: Props) => {
  const { aspect, children, cropOnlyWhenAspectMismatch, cropQuality, ...uploadProps } = props;

  return (
    <ImgCrop
      rotationSlider
      aspectSlider={aspect === "any"}
      aspect={aspect === "any" ? undefined : aspect ?? 3 / 2}
      quality={cropQuality}
      showReset
      beforeCrop={
        cropOnlyWhenAspectMismatch && typeof aspect === "number"
          ? async (file) => {
              if (!file.type.startsWith("image/")) return false;
              return !(await imageMatchesAspect(file, aspect));
            }
          : undefined
      }
    >
      <Upload {...uploadProps}>{children}</Upload>
    </ImgCrop>
  );
};
